import React from "react";
import { useSnapshot } from "valtio";
import { t } from "i18next";

import {
    generalConfigStore,
    setIsPageSkipped,
    setIsSalesMethodsSkipped,
} from "@store";

import { SwitchWrapper } from "@components/Common/SwitchWrapper";

export function SkipThisStepContainer(): JSX.Element {
    const {
        project: { template },
    } = useSnapshot(generalConfigStore);

    const [skipStep, setSkipStep] = React.useState<boolean>(
        (template.pages.ways.salesMethods as PageType).skipped as boolean
    );

    function handleSkipThisStepOnClickEvent() {
        setSkipStep(!skipStep);
        setIsPageSkipped("salesMethods", !skipStep);
        setIsSalesMethodsSkipped(!skipStep);
    }

    React.useEffect(() => {
        setSkipStep(
            (template.pages.ways.salesMethods as PageType).skipped as boolean
        );
    }, [template.pages.ways.salesMethods]);
    return (
        <div
            className="d-flex align-items-center justify-content-start cursor__clz"
            style={{ gap: "20px" }}
        >
            <div
                style={{
                    font: "normal normal 600 24px/32px Nunito Sans",
                }}
            >
                {t("Do not offer this step in the customer ways")}
            </div>
            <div className="Cmn_icn_proposeStageRoute">
                <SwitchWrapper
                    onChange={handleSkipThisStepOnClickEvent}
                    checked={skipStep}
                />
            </div>
        </div>
    );
}
